<template>
  <ListDropdown
    v-model="internalValue"
    class="sort-dropdown dropdown--simple"
    placeholder="Sortierung"
    label-on-selection
    label="Sortierung wählen"
    :options="options"
    :disabled="disabled"
    @input="onChange"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { cloneDeep } from 'lodash-es';
import { ListDropdown } from '@i22/td-longtail-vue-components';
import type { OfferSortField, SortDirection } from '~/lib/goliath/goliath.types';

export type SortValue = {
  field: OfferSortField;
  direction: SortDirection;
};

const DEFAULT_OPTIONS: { label: string; value: SortValue }[] = [
  {
    label: 'Beliebteste',
    value: {
      field: 'RECOMMENDATION' as OfferSortField.Recommendation,
      direction: 'ASC' as SortDirection.Asc,
    },
  },
  {
    label: 'Preis aufsteigend',
    value: {
      field: 'ONETIME_PRICE' as OfferSortField.OnetimePrice,
      direction: 'ASC' as SortDirection.Asc,
    },
  },
  {
    label: 'Preis absteigend',
    value: {
      field: 'ONETIME_PRICE' as OfferSortField.OnetimePrice,
      direction: 'DESC' as SortDirection.Desc,
    },
  },
  {
    label: 'Neu eingetroffen',
    value: {
      field: 'INSERTED_AT' as OfferSortField.InsertedAt,
      direction: 'DESC' as SortDirection.Desc,
    },
  },
];

const SEARCH_OPTIONS = [
  {
    label: 'Relevanz',
    value: { field: 'RELEVANCE', direction: 'ASC' },
  },
  ...cloneDeep(DEFAULT_OPTIONS),
];

export type SortDropdownProps = {
  value?: SortValue;
  itemUrl?: (value: any) => string;
  disabled?: boolean;
  searchContext?: boolean;
};

const props = withDefaults(defineProps<SortDropdownProps>(), {
  value: undefined,
  aggregations: undefined,
  itemUrl: undefined,
});

const emit = defineEmits<{
  (e: 'input', value: SortValue): void;
}>();

const internalValue = ref<SortValue | undefined>(props.value);
const options = computed(() => (props.searchContext ? SEARCH_OPTIONS : DEFAULT_OPTIONS));

watch(
  () => props.aggregations,
  (newValue: SortValue | undefined) => {
    internalValue.value = newValue ? { ...newValue } : undefined;
  }
);

const onChange = (value: SortValue) => {
  emit('input', value);
};

defineExpose({ onChange, options });
</script>
